import { getCurrentGruserSlice } from './grusers';
export const getPage = (state, gruser)=>getCurrentGruserSlice(state, gruser).page;
export const getPageName = (state, gruser)=>{
    var _getPage;
    return (_getPage = getPage(state, gruser)) === null || _getPage === void 0 ? void 0 : _getPage.name;
};
